// IMPORTANT Autogenerated file
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AssetTypeDto } from '@ellf/common-dto';
import { ApiClientConfig } from '../api-client-config';
import { BaseCRUDApiClient } from './baseCRUD.api-client';

@Injectable()
export class AssetTypeApiClient extends BaseCRUDApiClient<AssetTypeDto> {
  baseUrl = this.config.apiEndpoint + '/asset-type';

  constructor(http: HttpClient, config: ApiClientConfig) {
    super(http, config);
  }
}
